import React, { useState } from 'react';
import styles from "../../../styles/ai/research/AIResearch.module.css";

import ResearchHero from '../../../components/ai/research/ResearchHero';
import RagResearch from '../../../components/ai/research/RagResearch';
import FineTuningResearch from '../../../components/ai/research/FineTuningResearch';
import ConsultingResearch from '../../../components/ai/research/ConsultingResearch';

const AIResearch = () => {
  const [openRag, setOpenRag] = useState(false);
  const [openTune, setOpenTune] = useState(false);
  const [openConsult, setOpenConsult] = useState(false);

  return (
    <div className={styles.page}>
      <ResearchHero
        styles={styles}
        openRag={openRag}
        openTune={openTune} 
        openConsult={openConsult}
        onToggleRag={() => setOpenRag(v => !v)}
        onToggleTune={() => setOpenTune(v => !v)}
        onToggleConsult={() => setOpenConsult(v => !v)}
      />

      {openRag ? <RagResearch styles={styles} /> : null}
      {openTune ? <FineTuningResearch styles={styles} /> : null}
      {openConsult ? <ConsultingResearch styles={styles} /> : null}
    </div>
  )
}

export default AIResearch